import styled, { css } from 'styled-components'

import { Dialog } from '@syconium/little-miss-figgy/dist/components/Dialog'
import { Carat } from '@syconium/little-miss-figgy/dist/components/Icons/Icon/Carat'
import { SelectMark } from '@syconium/little-miss-figgy/dist/components/Icons/Icon/SelectMark'
import {
  easeInOutCubic,
  timingSlower,
  zIndexModal,
} from '@syconium/little-miss-figgy/dist/constants'
import { focusOutlineInset } from '@syconium/little-miss-figgy/dist/utility-classes'

export const navPushedBackTransition = css`
  transform ${timingSlower} ${easeInOutCubic}
`

// animation for mobile nav when overlay sub-nav slides in
export const navPushedBackCss = css`
  transition: ${navPushedBackTransition};

  &[data-nav-pushed-back='true'] {
    transform: translateX(-25%);
  }

  // 'prefers-reduced-motion' option for accessability
  @media (prefers-reduced-motion: reduce) {
    transition: none;

    &[data-nav-pushed-back='true'] {
      transform: none;
    }
  }
`

export const Drawer = styled(Dialog.Drawer)`
  z-index: ${zIndexModal + 1};
`

export const Header = styled.header`
  display: grid;
  text-align: center;
  font-weight: 700;
  grid-template-columns: ${o => o.theme.spacing(6)} 1fr ${o => o.theme.spacing(6)};
  align-items: center;
  gap: ${o => o.theme.spacing(2)};
  padding: ${o => o.theme.spacing(4)};
  border-bottom: 1px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.background};
  background-color: ${o => o.theme.color.fill.background};
  color: ${o => o.theme.color.text.primary.on.background};
  position: sticky;
  top: 0;
`

export const HeaderButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  ${focusOutlineInset};
`

export const BackIcon = styled(Carat).attrs({
  height: '18px',
  width: '18px',
  strokeWidth: 1,
})`
  transform: rotate(180deg);
`

export const CloseIcon = styled(SelectMark).attrs({
  height: '20px',
  width: '20px',
  strokeWidth: 1,
})``

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${o => o.theme.rowGap.medium};
  padding: ${o => o.theme.spacing(6, 4, 10)};
  background-color: ${o => o.theme.color.fill.background};
  color: ${o => o.theme.color.text.primary.on.background};
`
